// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3ht1O","inputWrap":"Table_inputWrap__2cL2f","col":"Table_col__29jCR","bmiTooltip":"Table_bmiTooltip__yNHU-"};